


















import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IUserAlert } from "../models/interfaces/user-alert.interface";

const UserModule = namespace("userModule");

@Component({})
export default class UserAlert extends Vue {
  @UserModule.Getter public userAlert: IUserAlert;
  @UserModule.Action public alertDismissed;
}
